import { createConfig, http } from 'wagmi';
import { injected, metaMask } from 'wagmi/connectors';
import { getWagmiChains } from './wagmi-chains';
import { getRabbyInjectedTarget, initEip6963Providers } from './evm-providers';
export function createWagmiConfig(appName, _projectId) {
    initEip6963Providers();
    const chains = getWagmiChains();
    if (chains.length === 0) {
        throw new Error('No EVM chains configured');
    }
    const transports = chains.reduce((acc, chain) => {
        acc[chain.id] = http();
        return acc;
    }, {});
    return createConfig({
        chains: chains,
        connectors: [
            metaMask({ dappMetadata: { name: appName } }),
            injected({
                target: () => getRabbyInjectedTarget(),
            }),
        ],
        transports,
        ssr: false,
    });
}
